var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "mobile-nav-toggle", class: _vm.rootClasses },
    [
      _c(
        "button",
        {
          staticClass: "mobile-nav-toggle--btn",
          attrs: { type: "button" },
          on: { click: _vm.onRequestMobileNavigation }
        },
        [
          _c(
            "span",
            { staticClass: "mobile-nav-toggle--wrap" },
            [
              _c("span", {
                staticClass: "mobile-nav-toggle--text",
                domProps: {
                  textContent: _vm._s(_vm.translate("MENU.BURGER_LABEL"))
                }
              }),
              _vm._v(" "),
              _c("cmp-icon", {
                staticClass: "mobile-nav-toggle--icon",
                attrs: { size: "large", symbol: "burger" }
              })
            ],
            1
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-52cf621e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-52cf621e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./vehi-industriepfad/assets/src/js/app/framework/components/mobile-nav-toggle/index.vue
// module id = 420
// module chunks = 5